import ErrorIcon from '@mui/icons-material/Error'
import MuiAlert from '@mui/material/Alert'
import { styled } from '@mui/system'
import { Job } from 'entities/Job'

import StatusIcon from './StatusIcon'

const Container = styled('div')(({ theme }) => ({
  maxHeight: 240,
  overflowX: 'hidden',
  overflowY: 'scroll',
  padding: theme.spacing(0.5),
}))

const JobItem = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  height: '1.25rem',
  whiteSpace: 'nowrap',
}))

const ErrorHint = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  fontSize: '0.8rem',
  whiteSpace: 'nowrap',
  marginTop: '0.2rem',
}))

const JobName = styled('div')({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
})

const Alert = styled(MuiAlert)(({ theme }) => ({
  marginTop: theme.spacing(0.5),
  marginBottom: theme.spacing(0.3),
  padding: '0.3rem',
  '& .MuiAlert-icon': {
    marginRight: theme.spacing(0.8),
  },
}))

const ErrorAlert = () => (
  <Alert severity="error">
    <div>ファイル登録エラーが発生しました。</div>
    <ErrorHint>
      詳細を確認するには
      <ErrorIcon color="error" fontSize="small" />
      にカーソルをあわせてください
    </ErrorHint>
  </Alert>
)

interface Props {
  someFailed: boolean
  jobs: Job[]
}

const JobsList = ({ jobs, someFailed }: Props) => {
  const jobItems = jobs.map((job) => {
    const { jobID, docName } = job
    return (
      <JobItem key={jobID}>
        {/* you can use isVerify like this job.isVerify ? 'verify' : 'normal' */}
        <StatusIcon job={job} message={job.displayMessage()} />
        <JobName>{docName}</JobName>
      </JobItem>
    )
  })

  return (
    <Container>
      {someFailed && <ErrorAlert />}
      {jobItems}
    </Container>
  )
}

export default JobsList
